import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productSearch'
})
export class ProductSearchPipe implements PipeTransform {

  transform(items: any[], filter: string): any[] {
    if (!items || !filter) {
      return items;
    }

    const normalize = (value: any): string =>
      String(value !== undefined && value !== null ? value : '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const query = normalize(filter);
    if (!query) {
      return items;
    }

    return items.filter(item => {
      const productName = normalize(item && item.product_name ? item.product_name : '');
      const productCode = normalize(item && item.productcode ? item.productcode : '');
      const combined = normalize(`${productName} ${productCode}`);
      const raw = normalize(JSON.stringify(item));

      return productName.includes(query) || productCode.includes(query) || combined.includes(query) || raw.includes(query);
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2505023020/src/src/app/shared/pipes/product-search.pipe.ts